import { render } from "./SummaryHistory.vue?vue&type=template&id=1681541a&ts=true"
import script from "./SummaryHistory.vue?vue&type=script&lang=ts"
export * from "./SummaryHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinnerFacebook,QTabs,QTab,QTabPanels,QTabPanel});
